<orbit-dialog-header [title]="'SETTINGS.CONVERSATION_TYPES.DIALOG.TITLE' | translate" />

<div class="dialog-content">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="basic-info-section">
      <div class="form-group">
        <orbit-form-field [label]="'Id' | translate" [name]="'id'" [controller]="id" />
      </div>

      <div class="form-group">
        <orbit-form-field
          [label]="'SETTINGS.CONVERSATION_TYPES.DESCRIPTION' | translate"
          [name]="'description'"
          [controller]="description"
          [inputType]="'textarea'" />
      </div>
    </div>

    <div class="templates-section">
      <div class="form-group">
        <div class="template-container">
          <div class="editor-section">
            <orbit-form-field-header
              [label]="'SETTINGS.CONVERSATION_TYPES.DIALOG.HEADER_TEMPLATE' | translate" />
            <orbit-input
              [inputType]="'textarea'"
              [name]="'conversationDataListItemTemplate'"
              [controller]="conversationDataListItemTemplate" />
            <orbit-input
              [inputType]="'textarea'"
              [name]="'headerTemplateData'"
              [controller]="headerTemplateDataForm" />
          </div>
          <div class="preview-section">
            <orbit-form-field-header [label]="'SETTINGS.CONVERSATION_TYPES.PREVIEW' | translate" />
            <div class="preview-container" [innerHTML]="headerPreview"></div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="template-container">
          <div class="editor-section">
            <orbit-form-field-header
              [label]="
                'SETTINGS.CONVERSATION_TYPES.DIALOG.CLIENT_APP_HEADER_TEMPLATE' | translate
              " />
            <orbit-input
              [inputType]="'textarea'"
              [name]="'clientAppHeaderTemplate'"
              [controller]="clientAppHeaderTemplate" />
            <orbit-input
              [inputType]="'textarea'"
              [name]="'clientAppHeaderTemplateData'"
              [controller]="clientAppHeaderTemplateData" />
          </div>
          <div class="preview-section">
            <orbit-form-field-header [label]="'SETTINGS.CONVERSATION_TYPES.PREVIEW' | translate" />
            <div class="preview-container" [innerHTML]="listPreview"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="additional-settings-section">
      <div class="form-group">
        <orbit-form-field-header
          [label]="'SETTINGS.CONVERSATION_TYPES.DIALOG.CONVERSATION_DATA_SCHEMA' | translate" />
        <orbit-input
          [name]="'conversationDataSchema'"
          [controller]="conversationDataSchema"
          [textareaAutosizeLimit]="{ minRows: 6, maxRows: 20 }"
          [inputType]="'textarea'" />
      </div>

      <div class="inline-fields">
        <div class="form-group">
          <orbit-form-field
            [label]="'SETTINGS.CONVERSATION_TYPES.DIALOG.DISPLAY_NAME_SHARED_BY_USERS' | translate"
            [name]="'displayNameSharedByUsers'"
            [controller]="displayNameSharedByUsers" />
        </div>
        <div class="form-group">
          <orbit-form-field
            [label]="
              'SETTINGS.CONVERSATION_TYPES.DIALOG.DISPLAY_NAME_FOR_WORKFLOW_PARTICIPANTS'
                | translate
            "
            [name]="'displayNameForWorkflowParticipants'"
            [controller]="displayNameForWorkflowParticipants" />
        </div>
        <div class="form-group">
          <orbit-form-field-header
            [label]="'SETTINGS.CONVERSATION_TYPES.DIALOG.SHARED_USER_READ_STATUS' | translate" />
          <orbit-checkbox
            [name]="'sharedReadStatusForUserParticipants'"
            [controller]="sharedReadStatusForUserParticipants"
            [id]="'sharedReadStatusForUserParticipants'" />
        </div>
      </div>
      <div class="inline-fields">
        <div class="form-group">
          <orbit-form-field
            [label]="'SETTINGS.CONVERSATION_TYPES.DIALOG.SMS_SENDER_ID' | translate"
            [name]="'smsSenderId'"
            [controller]="smsSenderId" />
        </div>
        <div class="form-group">
          <orbit-form-field
            [label]="'SETTINGS.CONVERSATION_TYPES.DIALOG.RETENTION_POLICY_DAYS' | translate"
            [name]="'retentionPolicyDays'"
            [controller]="retentionPolicyDays"
            [inputType]="'number'"
            [placeholder]="'Enter number of days'" />
        </div>
      </div>

      <!-- Message Template Selection Section -->
      <div class="template-selection-section">
        <div class="form-group">
          <label for="emailTemplate">{{ 'SETTINGS.CONVERSATION_TYPES.DIALOG.EMAIL_TEMPLATE' | translate }}</label>
          <select id="emailTemplate" formControlName="emailTemplate">
            @for (template of emailTemplates(); track template.name) {
              <option [value]="template.name">
                {{ template.name }}
                @if (template.isSystemTemplate) {
                  <span> {{ 'SETTINGS.CONVERSATION_TYPES.DIALOG.SYSTEM_TEMPLATE_INDICATOR' | translate }}</span>
                }
              </option>
            }
          </select>
        </div>

        <div class="form-group">
          <label for="smsTemplate">{{ 'SETTINGS.CONVERSATION_TYPES.DIALOG.SMS_TEMPLATE' | translate }}</label>
          <select id="smsTemplate" formControlName="smsTemplate">
            @for (template of smsTemplates(); track template.name) {
              <option [value]="template.name">
                {{ template.name }}
                @if (template.isSystemTemplate) {
                  <span> {{ 'SETTINGS.CONVERSATION_TYPES.DIALOG.SYSTEM_TEMPLATE_INDICATOR' | translate }}</span>
                }
              </option>
            }
          </select>
        </div>

        <div class="form-group">
          <label for="locationTemplate">{{ 'SETTINGS.CONVERSATION_TYPES.DIALOG.LOCATION_TEMPLATE' | translate }}</label>
          <select id="locationTemplate" formControlName="locationTemplate">
            @for (template of locationTemplates(); track template.name) {
              <option [value]="template.name">
                {{ template.name }}
                @if (template.isSystemTemplate) {
                  <span> {{ 'SETTINGS.CONVERSATION_TYPES.DIALOG.SYSTEM_TEMPLATE_INDICATOR' | translate }}</span>
                }
              </option>
            }
          </select>
        </div>
      </div>
    </div>

    @let errorMessage = error ? error() : null;
    @if (errorMessage) {
      <div class="error-wrapper">
        <orbit-message
          [message]="errorMessage"
          [title]="'SHARED.CREATE_CONVERSATION_FORM.ERROR_TITLE' | translate"
          [severity]="'error'" />
      </div>
    }
  </form>
</div>

<orbit-dialog-footer>
  <div class="right-addon" right-addon>
    <orbit-button
      [flat]="true"
      [label]="'SETTINGS.CONVERSATION_TYPES.CANCEL' | translate"
      (onClick)="onCancel()" />
    <orbit-button
      [icon]="saveIcon"
      [disabled]="form.invalid"
      [label]="'SETTINGS.CONVERSATION_TYPES.SAVE' | translate"
      (onClick)="onSubmit()" />
  </div>
</orbit-dialog-footer>
